<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useEventParticipantStore } from "@/store/EventParticipant";
import { useUserProfileStore } from "@/store/UserProfile";
import { storeToRefs } from "pinia";
import Intercom, { boot, onHide, onShow, shutdown, update } from '@intercom/messenger-js-sdk';
import { hide, show } from "@intercom/messenger-js-sdk";
import { User } from "@models/User";

const route = useRoute();
const { isInEvent } = storeToRefs(useEventParticipantStore());
const { profile } = storeToRefs(useUserProfileStore());
const isIntercomOpen = ref(false);

const toggleIntercom = () => {
    if (isIntercomOpen.value) {
        hide();
    } else {
        show();
    }
    isIntercomOpen.value = !isIntercomOpen.value;
};

onMounted(() => {
    const profile = useUserProfileStore().profile as User;
    Intercom({
        app_id: 'mrqis9r2',
        user_id: profile.id, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
        name: profile.displayName, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
        email: profile.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    });
    onHide(() => {
        isIntercomOpen.value = false;
    });
    onShow(() => {
        isIntercomOpen.value = true;
    });
    const config = {
        hide_default_launcher: true,
        alignment: "right",
        horizontal_padding: 20,
        vertical_padding: 125,
    };
    update({
        ...config,
    });
});

onUnmounted(() => {
    shutdown();
});
</script>
<template>
    <div :class="{ 'hidden md:block': !isIntercomOpen }" class="app-beacon ">
        <button class="button is-circle is-primary no-min-width" @click="toggleIntercom">

            <svg v-if="isIntercomOpen" xmlns="http://www.w3.org/2000/svg" viewBox="20 20 20 20"
                fill="none">
                <path d="M38.125 27.625 30 35.375l-8.125-7.75" stroke="#fff" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
            <svg v-else class="help-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="15 15 30 30">
                <path
                    d="M41.216 29.026c0 3.576-.895 5.847-2.647 7.268l-.066.052c-.213.173-.448.362-.6.559a1.958 1.958 0 0 0-.311.562c-.086.233-.117.494-.144.719l-.008.062-.303 2.48c-.063.516-.102.834-.151 1.06a1.595 1.595 0 0 1-.04.151.091.091 0 0 1-.015.006 1.42 1.42 0 0 1-.137-.076 14.087 14.087 0 0 1-.868-.626l-2.98-2.244-.041-.03a3.046 3.046 0 0 0-.53-.343 2.061 2.061 0 0 0-.554-.17 3.13 3.13 0 0 0-.648-.016l-.054.002c-.496.023-1.014.034-1.553.034-4.41 0-7.28-.758-9.048-2.22-1.721-1.421-2.602-3.683-2.602-7.23 0-3.546.88-5.808 2.602-7.23 1.769-1.46 4.639-2.22 9.048-2.22 4.41 0 7.28.76 9.048 2.22 1.721 1.422 2.602 3.684 2.602 7.23Z"
                    stroke="#fff" stroke-width="2" class="line-path"></path>
            </svg>
        </button>
    </div>
</template>